/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import {
  monthShortLabel,
  type PenaltyPoint,
} from '@sportninja/common/features/playerFinder/penalties'
import React from 'react'
import { VictoryArea, VictoryAxis, VictoryChart, VictoryScatter } from 'victory'

export interface PenaltyLineChartProps {
  data: PenaltyPoint[]
}

/** Per-month penalty line with a filled area, mirroring the mobile chart. */
const PenaltyLineChart: React.FC<PenaltyLineChartProps> = ({ data }) => {
  const points = data.map((p) => ({
    x: monthShortLabel(p.month),
    y: p.penalties,
  }))

  return (
    <div css={wrapStyle}>
      <VictoryChart
        height={180}
        // Symmetric side padding: there is no Y axis, so the old left: 32 just
        // reserved empty space and pushed the plot off-centre. The remaining
        // inset only has to clear the first/last dot and its value label.
        padding={{ top: 24, bottom: 32, left: 16, right: 16 }}
      >
        <VictoryAxis
          style={{
            axis: { stroke: colors.SOFT_STEEL },
            tickLabels: { fill: colors.NEUTRAL_50, fontSize: 10 },
          }}
        />
        <VictoryArea
          data={points}
          interpolation='linear'
          style={{
            data: {
              fill: colors.INFO_300,
              fillOpacity: 0.15,
              stroke: colors.INFO_300,
              strokeWidth: 2,
            },
          }}
        />
        <VictoryScatter
          data={points}
          size={4}
          labels={({ datum }: { datum: { y: number } }) => String(datum.y)}
          style={{
            data: {
              fill: colors.HEADER,
              stroke: colors.INFO_300,
              strokeWidth: 2,
            },
            labels: { fill: colors.WHITE, fontSize: 10 },
          }}
        />
      </VictoryChart>
    </div>
  )
}

export default PenaltyLineChart

const wrapStyle = css`
  width: 100%;
`
